/* GreedySnake storefront interactions: scroll reveals, mini Snake game, playful add to cart. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveals ---------- */
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }) : null;

  function initReveals(root) {
    var items = root.querySelectorAll('[data-gs-reveal], [data-gs-in]');
    items.forEach(function (el) {
      if (!revealObserver || reduceMotion) { el.classList.add('is-in'); return; }
      revealObserver.observe(el);
    });
  }

  /* ---------- Mini Snake game ---------- */
  var COLS = 18;
  var games = new WeakMap();

  function SnakeGame(root) {
    this.root = root;
    this.canvas = root.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.screen = root.querySelector('.gs-game__screen');
    this.overlay = root.querySelector('[data-gs-overlay]');
    this.title = root.querySelector('[data-gs-title]');
    this.text = root.querySelector('[data-gs-text]');
    this.startBtn = root.querySelector('[data-gs-start]');
    this.shopLink = root.querySelector('[data-gs-shop]');
    this.scoreEl = root.querySelector('[data-gs-score]');
    this.bestEl = root.querySelector('[data-gs-best]');
    this.running = false;
    this.timer = null;
    this.best = 0;
    try { this.best = parseInt(localStorage.getItem('gs-best') || '0', 10) || 0; } catch (e) {}
    this.bestEl.textContent = this.best;
    this.bind();
    this.resize();
    this.reset();
    this.draw();
  }

  SnakeGame.prototype.bind = function () {
    var self = this;
    this.startBtn.addEventListener('click', function () { self.start(); });
    this.onKey = function (e) {
      if (!self.running) return;
      var map = { ArrowUp: 'up', ArrowDown: 'down', ArrowLeft: 'left', ArrowRight: 'right', w: 'up', s: 'down', a: 'left', d: 'right' };
      var dir = map[e.key];
      if (dir) { e.preventDefault(); self.turn(dir); }
    };
    document.addEventListener('keydown', this.onKey);
    this.root.querySelectorAll('[data-dir]').forEach(function (btn) {
      btn.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        if (!self.running) self.start();
        self.turn(btn.getAttribute('data-dir'));
        btn.classList.add('is-pressed');
        setTimeout(function () { btn.classList.remove('is-pressed'); }, 120);
      });
    });
    var sx = 0, sy = 0;
    this.screen.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    this.screen.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 24 || !self.running) return;
      self.turn(Math.abs(dx) > Math.abs(dy) ? (dx > 0 ? 'right' : 'left') : (dy > 0 ? 'down' : 'up'));
    }, { passive: true });
    this.onResize = function () { self.resize(); self.draw(); };
    window.addEventListener('resize', this.onResize);
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting && self.running) self.pause();
      }, { threshold: 0.2 });
      this.io.observe(this.screen);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden && self.running) self.pause(); });
  };

  SnakeGame.prototype.resize = function () {
    var size = this.screen.clientWidth;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.canvas.width = Math.round(size * dpr);
    this.canvas.height = Math.round(size * dpr);
    this.cell = this.canvas.width / COLS;
  };

  SnakeGame.prototype.reset = function () {
    var mid = Math.floor(COLS / 2);
    this.snake = [{ x: mid, y: mid }, { x: mid - 1, y: mid }, { x: mid - 2, y: mid }];
    this.dir = 'right';
    this.queue = [];
    this.score = 0;
    this.speed = 150;
    this.scoreEl.textContent = '0';
    this.placeFood();
  };

  SnakeGame.prototype.placeFood = function () {
    var free;
    do {
      free = { x: Math.floor(Math.random() * COLS), y: Math.floor(Math.random() * COLS) };
    } while (this.snake.some(function (s) { return s.x === free.x && s.y === free.y; }));
    free.beige = Math.random() > 0.5;
    this.food = free;
  };

  SnakeGame.prototype.turn = function (dir) {
    var last = this.queue.length ? this.queue[this.queue.length - 1] : this.dir;
    var opposite = { up: 'down', down: 'up', left: 'right', right: 'left' };
    if (dir !== last && dir !== opposite[last] && this.queue.length < 3) this.queue.push(dir);
  };

  SnakeGame.prototype.start = function () {
    if (this.running) return;
    if (this.over) { this.reset(); this.over = false; }
    this.overlay.hidden = true;
    this.running = true;
    this.loop();
  };

  SnakeGame.prototype.pause = function () {
    this.running = false;
    clearTimeout(this.timer);
    this.title.textContent = this.title.getAttribute('data-paused');
    this.text.textContent = this.text.getAttribute('data-paused');
    this.startBtn.textContent = this.startBtn.getAttribute('data-resume');
    if (this.shopLink) this.shopLink.hidden = true;
    this.overlay.hidden = false;
  };

  SnakeGame.prototype.loop = function () {
    var self = this;
    this.step();
    this.draw();
    if (this.running) this.timer = setTimeout(function () { self.loop(); }, this.speed);
  };

  SnakeGame.prototype.step = function () {
    if (this.queue.length) this.dir = this.queue.shift();
    var head = this.snake[0];
    var move = { up: [0, -1], down: [0, 1], left: [-1, 0], right: [1, 0] }[this.dir];
    var next = { x: (head.x + move[0] + COLS) % COLS, y: (head.y + move[1] + COLS) % COLS };
    var ate = next.x === this.food.x && next.y === this.food.y;
    var body = ate ? this.snake : this.snake.slice(0, -1);
    if (body.some(function (s) { return s.x === next.x && s.y === next.y; })) { this.end(); return; }
    this.snake.unshift(next);
    if (ate) {
      this.score += 1;
      this.scoreEl.textContent = this.score;
      this.speed = Math.max(70, 150 - this.score * 4);
      this.placeFood();
      this.screen.animate && !reduceMotion && this.screen.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.015)' }, { transform: 'scale(1)' }], { duration: 180 });
    } else {
      this.snake.pop();
    }
  };

  SnakeGame.prototype.end = function () {
    this.running = false;
    this.over = true;
    clearTimeout(this.timer);
    if (this.score > this.best) {
      this.best = this.score;
      this.bestEl.textContent = this.best;
      try { localStorage.setItem('gs-best', String(this.best)); } catch (e) {}
    }
    var blocks = this.score + this.snake.length - 1;
    this.title.textContent = this.title.getAttribute('data-over');
    this.text.textContent = this.text.getAttribute('data-over').replace('[n]', blocks);
    this.startBtn.textContent = this.startBtn.getAttribute('data-again');
    if (this.shopLink) this.shopLink.hidden = false;
    this.overlay.hidden = false;
  };

  function capsule(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  SnakeGame.prototype.draw = function () {
    var ctx = this.ctx, c = this.cell, W = this.canvas.width;
    ctx.fillStyle = '#f3fbe9';
    ctx.fillRect(0, 0, W, W);
    ctx.fillStyle = 'rgba(30,51,32,0.14)';
    for (var gx = 0; gx < COLS; gx++) {
      for (var gy = 0; gy < COLS; gy++) {
        ctx.beginPath(); ctx.arc(gx * c + c / 2, gy * c + c / 2, c * 0.07, 0, Math.PI * 2); ctx.fill();
      }
    }
    var lw = Math.max(2, c * 0.1);
    ctx.lineWidth = lw;
    ctx.strokeStyle = '#1e3320';
    var f = this.food, pad = c * 0.14;
    ctx.fillStyle = f.beige ? '#f0e2c6' : '#cdebc4';
    capsule(ctx, f.x * c + pad, f.y * c + c * 0.22, c - pad * 2, c * 0.56, c * 0.24);
    ctx.fill(); ctx.stroke();
    for (var i = this.snake.length - 1; i >= 0; i--) {
      var s = this.snake[i], p = c * 0.06;
      if (i === 0) {
        ctx.fillStyle = '#3fa34d';
        capsule(ctx, s.x * c + p, s.y * c + p, c - p * 2, c - p * 2, c * 0.4);
        ctx.fill(); ctx.stroke();
        var dx = { up: 0, down: 0, left: -1, right: 1 }[this.dir], dy = { up: -1, down: 1, left: 0, right: 0 }[this.dir];
        var cx = s.x * c + c / 2, cy = s.y * c + c / 2, off = c * 0.2;
        var eyes = dx !== 0 ? [[cx + dx * off * 0.6, cy - off], [cx + dx * off * 0.6, cy + off]] : [[cx - off, cy + dy * off * 0.6], [cx + off, cy + dy * off * 0.6]];
        eyes.forEach(function (e) {
          ctx.fillStyle = '#fffbf3'; ctx.beginPath(); ctx.arc(e[0], e[1], c * 0.15, 0, Math.PI * 2); ctx.fill();
          ctx.fillStyle = '#1e3320'; ctx.beginPath(); ctx.arc(e[0] + dx * c * 0.05, e[1] + dy * c * 0.05, c * 0.075, 0, Math.PI * 2); ctx.fill();
        });
      } else {
        ctx.fillStyle = i % 2 ? '#cdebc4' : '#f0e2c6';
        capsule(ctx, s.x * c + p, s.y * c + p * 2, c - p * 2, c - p * 4, c * 0.26);
        ctx.fill(); ctx.stroke();
      }
    }
  };

  function initGames(root) {
    root.querySelectorAll('[data-gs-game]').forEach(function (el) {
      if (!games.has(el)) games.set(el, new SnakeGame(el));
    });
  }

  /* ---------- Playful add to cart ---------- */
  function burst(x, y) {
    if (reduceMotion) return;
    var box = document.createElement('div');
    box.className = 'gs-burst';
    box.style.left = x + 'px';
    box.style.top = y + 'px';
    for (var i = 0; i < 12; i++) {
      var b = document.createElement('span');
      var a = (Math.PI * 2 * i) / 12;
      var d = 70 + Math.random() * 70;
      b.className = 'gs-block gs-block--sm' + (i % 2 ? ' gs-block--beige' : '');
      b.style.setProperty('--x', Math.cos(a) * d + 'px');
      b.style.setProperty('--y', Math.sin(a) * d + 'px');
      b.style.setProperty('--r', Math.round(Math.random() * 360) + 'deg');
      box.appendChild(b);
    }
    document.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 1000);
  }

  function initBuyForms(root) {
    root.querySelectorAll('[data-gs-buy]').forEach(function (form) {
      if (form.dataset.gsBound) return;
      form.dataset.gsBound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var msg = form.parentElement.querySelector('[data-gs-msg]');
        var rect = btn.getBoundingClientRect();
        btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          burst(rect.left + rect.width / 2, rect.top + rect.height / 2);
          if (msg) msg.textContent = msg.getAttribute('data-ok');
          setTimeout(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }, reduceMotion ? 200 : 900);
        }).catch(function () {
          btn.disabled = false;
          form.submit();
        });
      });
    });
  }

  function init(root) {
    initReveals(root);
    initGames(root);
    initBuyForms(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();